
import { Options, Vue } from "vue-class-component";
import { paceUnits } from "../models/units";

@Options({
  props: {
    paceSeconds: Number,
    paceMinutes: Number,
    unit: Number,
  },
})
export default class PaceSelector extends Vue {
  paceSeconds!: number;
  paceMinutes!: number;
  unit!: number;
  paceUnits = paceUnits;

  updateSeconds(value: number) {
    this.$emit("updateSeconds", value);
  }
  updateMinutes(value: number) {
    this.$emit("updateMinutes", value);
  }
  updateUnit(value: number) {
    this.$emit("updateUnit", value);
  }
}
